import React from 'react';

export const HEADER_CARD_STYLE = {
  background: 'linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%)',
  padding: '10px 14px',
  borderRadius: '8px 8px 0 0',
  border: '1px solid #dfe1e6',
  boxShadow: '0 1px 3px rgba(9,45,66,0.08)',
  margin: '10px 10px 0',
};

export const HEADER_LAYOUT_STYLE = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
};

export const HEADER_LEFT_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  minWidth: 0,
};

export const HEADER_ICON_STYLE = (background, shadowColor) => ({
  width: 36,
  height: 36,
  background,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  boxShadow: shadowColor ? `0 2px 4px ${shadowColor}` : 'none',
  flexShrink: 0,
});

export const HEADER_TITLE_STYLE = (color) => ({
  margin: 0,
  fontSize: 17,
  lineHeight: 1.2,
  fontWeight: 700,
  color: color || '#0052CC',
  letterSpacing: '-0.2px',
});

export const HEADER_SUBTITLE_STYLE = {
  margin: '3px 0 0',
  fontSize: 12,
  lineHeight: 1.35,
  color: '#5E6C84',
  fontWeight: 400,
};

export const HEADER_ACTIONS_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 8,
  flexWrap: 'wrap',
  marginLeft: 'auto',
};

export const HEADER_META_TEXT_STYLE = {
  fontSize: 11,
  color: '#5E6C84',
  fontWeight: 500,
};

export const getHeaderPrimaryButtonStyle = (color = '#0052CC') => ({
  backgroundColor: color,
  color: '#fff',
  border: 'none',
  padding: '6px 12px',
  borderRadius: 4,
  fontSize: 12,
  lineHeight: 1.2,
  fontWeight: 700,
  cursor: 'pointer',
  minHeight: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
});

export const getHeaderSecondaryButtonStyle = (color = '#0052CC') => ({
  backgroundColor: '#fff',
  color,
  border: `1px solid ${color === '#42526E' ? '#DFE1E6' : color}`,
  padding: '6px 12px',
  borderRadius: 4,
  fontSize: 12,
  lineHeight: 1.2,
  fontWeight: 600,
  cursor: 'pointer',
  minHeight: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
});

export const ReadyBadge = ({ color = '#0C66E4', label = 'Ready' }) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: '#E9F2FF',
      padding: '4px 10px',
      borderRadius: 999,
      border: '1px solid #B3D4FF',
      minHeight: 28,
      boxSizing: 'border-box',
    }}
  >
    <div style={{ width: 6, height: 6, borderRadius: '50%', background: color }} />
    <span style={{ color, fontSize: 12, fontWeight: 600, lineHeight: 1 }}>{label}</span>
  </div>
);

const ConsultantTabHeader = ({
  title,
  subtitle,
  icon,
  iconBackground,
  iconShadowColor,
  titleColor,
  actions,
}) => {
  return (
    <div style={HEADER_CARD_STYLE}>
      <div style={HEADER_LAYOUT_STYLE}>
        <div style={HEADER_LEFT_STYLE}>
          <div style={HEADER_ICON_STYLE(iconBackground, iconShadowColor)}>{icon}</div>
          <div style={{ minWidth: 0 }}>
            <h2 style={HEADER_TITLE_STYLE(titleColor)}>{title}</h2>
            <p style={HEADER_SUBTITLE_STYLE}>{subtitle}</p>
          </div>
        </div>

        <div style={HEADER_ACTIONS_STYLE}>{actions}</div>
      </div>
    </div>
  );
};

export default ConsultantTabHeader;
